"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugClientForwarder = exports.ButtplugClientForwarderBrowserWebsocketConnector = void 0;
const Messages_1 = require("../core/Messages");
const Exceptions_1 = require("../core/Exceptions");
const Utils_1 = require("../utils/Utils");
const ButtplugBrowserWebsocketConnector_1 = require("../utils/ButtplugBrowserWebsocketConnector");
class ButtplugClientForwarderBrowserWebsocketConnector extends ButtplugBrowserWebsocketConnector_1.ButtplugBrowserWebsocketConnector {
    constructor(serverAddress) {
        super(serverAddress);
    }
    SendForwardedMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            // Expect that we'll just get Ok or Error back.
            this.SendMessage(message);
            return Promise.resolve();
        });
    }
}
exports.ButtplugClientForwarderBrowserWebsocketConnector = ButtplugClientForwarderBrowserWebsocketConnector;
class ButtplugClientForwarder {
    constructor(clientName, connector) {
        this._devices = new Map();
        this.Connect = () => __awaiter(this, void 0, void 0, function* () {
            yield this._connector.Connect();
            this._connector.addListener("message", (msgs) => __awaiter(this, void 0, void 0, function* () {
                for (const m of msgs) {
                    yield this.ReceiveDeviceCommand(m);
                }
            }));
        });
        this.Disconnect = () => __awaiter(this, void 0, void 0, function* () {
            yield this._connector.Disconnect();
        });
        this.AddDevice = (device) => __awaiter(this, void 0, void 0, function* () {
            const msg = this.CreateDeviceAdded(device);
            device.addListener("deviceremoved", () => this.RemoveDevice(device));
            yield this._connector.SendForwardedMessage(msg);
        });
        this.RemoveDevice = (device) => __awaiter(this, void 0, void 0, function* () {
            const msg = this.CreateDeviceRemoved(device);
            yield this._connector.SendForwardedMessage(msg);
        });
        this.ReceiveDeviceCommand = (message) => __awaiter(this, void 0, void 0, function* () {
            // Parse command and forward to actual device.
            const device = this._devices.get(message.DeviceIndex);
            if (device === undefined) {
                return;
            }
            // TODO This could fail if we don't find the device.
            //
            // TODO If this fails on the device (doesn't support message, etc...),
            // it'll throw. It should try, catch the exception, forward it to the
            // server.
            yield (device === null || device === void 0 ? void 0 : device.SendMessageAsync(message));
            // Assume if we made it this far that we're just sending back an Ok with
            // Id match.
            yield this._connector.SendForwardedMessage(new Messages_1.Ok(message.Id));
        });
        // We should prepend the client name to our devices before sending them out.
        this._clientName = clientName;
        this._connector = connector;
    }
    CreateDeviceAdded(device) {
        const deviceKeys = [...this._devices.entries()]
            .filter(({ 1: v }) => v.Index === device.Index)
            .map(([k]) => k);
        if (deviceKeys.length > 0) {
            throw new Exceptions_1.ButtplugDeviceException("Device already shared with server!");
        }
        let localId = Utils_1.getRandomInt(2 ^ 32);
        // Just in case.
        while (this._devices.has(localId)) {
            localId = Utils_1.getRandomInt(2 ^ 32);
        }
        this._devices.set(localId, device);
        return new Messages_1.DeviceAdded(localId, `${this._clientName} - ${device.Name}`, device.AllowedMessagesObject);
    }
    CreateDeviceRemoved(device) {
        const deviceKeys = [...this._devices.entries()]
            .filter(({ 1: v }) => v.Index === device.Index)
            .map(([k]) => k);
        if (deviceKeys.length === 1) {
            const key = deviceKeys.pop();
            this._devices.delete(key);
            return new Messages_1.DeviceRemoved(key);
        }
        else if (deviceKeys.length === 0) {
            throw new Exceptions_1.ButtplugDeviceException("Device not currently shared with server!");
        }
        else {
            throw new Exceptions_1.ButtplugDeviceException("Device shared with server multiple times!");
        }
    }
}
exports.ButtplugClientForwarder = ButtplugClientForwarder;
//# sourceMappingURL=ButtplugClientForwarder.js.map